export default "__VITE_ASSET__Bqbi$zwP__"